module.exports = __webpack_public_path__ + "static/fills@2x-deb88de43cc7dde0693b4d19223a77ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/fills@2x.png
// module id = 2603
// module chunks = 168707334958949